<template>
<div class="detail">
    <div class="p_title">
      <div class="no" @click="isOpen2=!isOpen2">
        <img src="../../assets/60.png">{{request.callRquestOrderNo}}<img class="jt" :class="{ open: isOpen2}" src="../../assets/61.png">
        <div v-if="isOpen2">
          
          <div class="row"><img src="../../assets/73.png">{{request.customerCompanyName }}</div>   
          <div class="row"><img src="../../assets/74.png">{{request.customerAddress }}</div>   
          <div class="row"><img src="../../assets/75.png">{{request.serviceCreateTimeStr}}</div>   
          <div class="row"><img src="../../assets/76.png">{{request.customerName}}</div> 
          <div class="row"><img src="../../assets/77.png">{{request.customerTel}}</div>
          <div  class="row wrongmobile"><div><img src="../../assets/78.png">{{request.memberMoblie}}</div><div v-if="request.status<4&&request.dataSource==0" class="wrongicon" @click="WrongMobile()">反馈号码有误</div> </div>  
        </div> 
      </div>
    </div>
    <div class="jd"><img src="../../assets/62.png" />{{request.statusStr}}</div>
    <div class="first box">
      <div class="title"><img src="../../assets/63.png" />叫修内容</div>  
      <div class="row">{{request.categoryName}}</div>
      <div class="row">{{request.faultDescription}}</div>
      
       <attach-upload
       
        :canUpload="false"
        
        :maxLength="9"
        
        v-model="request.attachmentList"
        
      ></attach-upload>
    </div>
    <div class="box">
      <div class="title"><img src="../../assets/64.png" />处理进度</div>
      <div class="second" :class="{ open: isOpen}">
        <div class="operationList"  v-for="(item,index) in request.callRequestOperationLog" :key="index">
          <div class="operationItem">
            <img class="img" v-if="index==0" src="../../assets/66.png">
            <img class="img" v-else-if="index==request.callRequestOperationLog.length-1" src="../../assets/68.png">
            <img class="img" v-else src="../../assets/67.png">
            <div class="oparationTime">{{item.createDateTimeStr}}</div>
            
            <div class="oparation" style="width: calc(100% - 12rem);">{{item.action}}</div>
          </div>
          <div class="operationactions" v-if="item.serviceUserName!=null&&item.isComplete">{{item.serviceUserName}}完成了维修，{{item.result}}</div>
          <div class="operationactions" v-if="item.serviceUserName!=null&&!item.isComplete">{{item.serviceUserName}}部分完成了维修，{{item.result}}</div>
          <div class="operationactions" v-if="item.callServiceAttachmentList!=null&&item.callServiceAttachmentList.length>0">
                <attach-upload
       
                    :canUpload="false"
                    
                    :maxLength="9"
                    
                    v-model="item.callServiceAttachmentList"
                    
                ></attach-upload>
          </div>
        </div>

       

      </div>
      <div class="btn" :class="{ open: isOpen}" @click="isOpen=!isOpen"><img src="../../assets/1.jpg" /></div>
    </div>
    
    <div v-if="request.status==6&&request.processingResults!=0" class="question">
      <div class="box">
        <div class="title"><img src="../../assets/79.png" />服务评价</div>
          <ul>
              <li class="lab">
                  <span class="lispan">技术工程师是否已解决您的问题 ？</span>
                  <div class="lidiv">
                      <input disabled style="margin-left: 20px;" type="radio" name="solve" id="yes" value="true" v-model="request.isProblemSolved" checked />
                      <label for="yes" style="margin-right:40px;margin-left: 10px;">已解决</label>
                      <input disabled type="radio" name="solve" id="no" value="false" v-model="request.isProblemSolved" />
                      <label for="no" style="margin-left: 10px;">未解决</label>
                  </div>
              </li>
              <li>
                  <span class="lispan">请对服务进行评分</span>
                  <div class="t">
                      <span>处理结果</span>
                      <ul class="star">
                          <li v-for="(star, index) in 5" :key="index" :class="{active:request.processingResults >= star}"><span></span></li>
                      </ul>
                  </div>
                  <div class="t">
                      <span>处理态度</span>
                      <ul class="star">
                          <li v-for="(star, index) in 5" :key="index" :class="{active:request.processingAttitude >= star}"><span></span></li>
                      </ul>
                  </div>
                  <div class="t">
                      <span>处理速度</span>
                      <ul class="star">
                          <li v-for="(star, index) in 5" :key="index" :class="{active:request.processingSpeed >= star}"><span></span></li>
                      </ul>
                  </div>
              </li>
          </ul>
          <mt-field readonly placeholder="请输入..." v-model="request.appraiseDescription" :attr="{ maxlength: 300 }" type="textarea" rows="3"></mt-field>
      </div>
      <div class="clear"></div>
  </div>

   

   <div v-if="request.status==2"  class="row_bottom">
        <div class="left" @click="CallCustomer(request.memberMoblie)">联系顾客</div>
        <div class="right" @click="GetOrder(request.callRquestOrderNo)">接单</div>
   </div>
   <div v-if="request.status==3"  class="row_bottom">
        <div class="left" @click="CallCustomer(request.memberMoblie)">联系顾客</div>
        <div v-if="!request.waitComfirmOnsiteTime" class="right" @click="ArrivePlace(request.callRquestOrderNo)">到达现场</div>
        <div v-if="request.waitComfirmOnsiteTime" class="right" @click="NowSetOnsiteTime(request.callRquestOrderNo)">预计上门时间</div>
     
   </div>
   <div v-if="request.status==4"  class="row_bottom">
        <div class="left" @click="PartiallyCpmplete(request.memberMoblie)">部分完成</div>
        <div class="right" @click="CompleteService()">完成维修</div>
     
   </div>
                    <mt-popup
                        v-model="popupVisible"
                        class="popup"
                       >
                       <html style="z-index:1">
                        <div style="padding:2rem">
                            <div   class="poopdiv">
                                   <div class="title"><span>服务方式</span></div>
                                    <mt-radio
                                    
                                    class="callradio"
                                        v-model="callRequest.IsOnSiteServiceStr"
                                        :options="['现场服务', '远程服务']">
                                    </mt-radio>
                                </div>

                                <div  style="margin-top:20px;" v-if="callRequest.IsOnSiteServiceStr=='现场服务'"  class="poopdiv">
                                    
                                     <div class="title"><span>预计上门时间</span></div>
                                <div class="mint-cell-value" style="display:flex;flex-direction: column;">
                                    <input
                                    style="margin-left:4rem;margin-top:1rem;"
                                    placeholder="日期"
                                    @click="ShowStartDatePicker"
                                    v-model="callRequest.CurrentEstimateOnSiteDate"
                                    type="text"
                                    readonly
                                    class="mint-field-core"
                                    />
                                   
                                </div>
                                <div class="mint-cell-value" style="display:flex;flex-direction: column;">
                                    <input
                                    v-if="callRequest.CurrentEstimateOnSiteDate!=''"
                                    style="margin-left:4rem;margin-top:1rem;"
                                    placeholder="选择上午/下午"
                                    @click="ShowMorningPicker"
                                    v-model="callRequest.CurrentEstimateOnSiteTime"
                                    type="text"
                                    readonly
                                    class="mint-field-core"
                                    />
                                    
                                   
                                </div>
                                    
                                </div>
                                <div style="margin-top:20px;" v-if="callRequest.IsOnSiteServiceStr=='远程服务'"  class="poopdiv">
                                     <div class="title"><span>备注</span></div>
                                    <textarea class="proptextarea" placeholder="请输入备注" v-model="callRequest.Comment"></textarea>
                                </div>
                            </div>
                            <div v-if="callRequest.IsOnSiteServiceStr=='远程服务'" @click="ConfirmTakeOrder" class="confirm">确认</div>
                            <div v-if="callRequest.IsOnSiteServiceStr!='远程服务'"  class="confirmdiv">
                                <div @click="WaitTimeConfirmTakeOrder" class="left">稍后预计时间</div>
                                <div @click="ConfirmTakeOrder" class="right">确认</div>
                            </div>
                       </html>
                    </mt-popup>

                        <mt-datetime-picker
                                    v-model="startDatePicker"
                                    ref="startDatePicker"
                                    type="date"
                                    
                                    month-format="{value} 月"
                                    date-format="{value} 日"
                                    @confirm="HandleStartDateConfirm"
                                    >
            </mt-datetime-picker>

            <mt-popup v-model="popupVisible2" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%;">
                    <mt-picker :slots="slots" @change="onValuesChange" value-key="categoryName" style="width: 100%;" showToolbar>
                        <div class="picker-toolbar-title">
                            <div class="mint-datetime-action mint-datetime-cancel" @click="popupVisible2 = !popupVisible2">关闭</div>
                            <div class="mint-datetime-action mint-datetime-confirm" @click="confirmSelect">确定</div>
                        </div>
                    </mt-picker>
                </mt-popup>

                <mt-popup
                        v-model="popupVisible3"
                        class="popup"
                       >
                       <html style="z-index:1">
                        <div style="padding:2rem">
                            <div   class="poopdiv">
                                     <div class="title"><span>处理结果</span></div>
                                       
                                        <mt-radio
                                        
                                        class="callradio"
                                            v-model="callRequest.InWarrantyTimeStr"
                                            :options="['质保期内', '质保期外']">
                                        </mt-radio>
                                        <mt-radio
                                        style="width:100%;"
                                        class="callradio"
                                            v-model="callRequest.IsRepairStr"
                                            :options="['更换', '维修']">
                                        </mt-radio>
                                        
                                  
                                    <mt-radio
                                        style="width:100%;"
                                        class="callradio"
                                            v-model="callRequest.IsFreeStr"
                                            :options="['免费', '有费']">
                                        </mt-radio>
                                </div>
                                <div style="margin-top:20px;">上传维修凭证</div>
                                <attach-upload
       
                                    :canUpload="true"
                                   
                                    :maxLength="9"
                                    v-model="callRequest.attachmentList"
                                    :contractType="createType"
                                ></attach-upload>
                                <div  style="margin-20px;" class="poopdiv">
                                 <textarea  style="width:100%;height:80px;" class="proptextarea" :placeholder="callRequest.ShowResult" v-model="callRequest.Result"></textarea>
                                   
                                </div>

                                
                        </div>
                           <div   class="confirmdiv">
                                <div @click="cancelSubmit" class="left">取消</div>
                                <div @click="CompleteCallService" class="right">确认</div>
                            </div>
                       </html>
                    </mt-popup>

                    <mt-popup
                        v-model="popupVisible4"
                        class="popup"
                       >
                       <html style="z-index:1">
                        <div style="padding:2rem">
                            <div   class="poopdiv">
                                     <div class="title"><span>处理结果</span></div>
                                    
                                        <mt-radio
                                        style="width:100%;"
                                        class="callradio"
                                            v-model="callRequest.InWarrantyTimeStr"
                                            :options="['质保期内', '质保期外']">
                                        </mt-radio>
                                        <mt-radio
                                        style="width:100%;"
                                        class="callradio"
                                            v-model="callRequest.IsRepairStr"
                                            :options="['更换', '维修']">
                                        </mt-radio>
                                        
                                   
                                    <mt-radio
                                        style="width:100%;"
                                        class="callradio"
                                            v-model="callRequest.IsFreeStr"
                                            :options="['免费', '有费']">
                                        </mt-radio>
                                </div>
                                <attach-upload
       
                                    :canUpload="true"
                                   
                                    :maxLength="9"
                                    v-model="callRequest.partattachmentList"
                                    :contractType="createType"
                                ></attach-upload>
                                <div  style="margin-top:20px;" class="poopdiv">
                                 <textarea  style="width:100%;height:80px;" class="proptextarea" placeholder="请填写本次维修的详情内容" v-model="callRequest.Result"></textarea>
                                   
                                </div>

                                <div  style="margin-top:20px;"  class="poopdiv date">
                                     <div class="title"><span>预计上门时间</span></div>
                                <div class="mint-cell-value" style="display:flex;flex-direction: column; margin:0" >
                                    <input
                                    style="margin-left:4rem;margin-top:1rem;"
                                    placeholder="日期"
                                    @click="ShowStartDatePicker"
                                    v-model="callRequest.CurrentEstimateOnSiteDate"
                                    type="text"
                                    readonly
                                    class="mint-field-core"
                                    />
                                   
                                </div>
                                <div class="mint-cell-value" style="display:flex;flex-direction: column;">
                                    <input
                                    v-if="callRequest.CurrentEstimateOnSiteDate!=''"
                                    style="margin-left:4rem;margin-top:1rem;"
                                    placeholder="选择上午/下午"
                                    @click="ShowMorningPicker"
                                    v-model="callRequest.CurrentEstimateOnSiteTime"
                                    type="text"
                                    readonly
                                    class="mint-field-core"
                                    />
                                    
                                   
                                </div>
                                    
                                </div>
                                
                        </div>
                           <div   class="confirmdiv" style="margin-top:30px;">
                                <div style="background-color:#ff6600" @click="cancelSubmit" class="left">取消</div>
                                <div @click="PartiallyCompleteCallServiceWithNoTime" class="left">稍后确认时间</div>
                                <div @click="PartiallyCompleteCallService" class="right">确认</div>
                            </div>
                       </html>
                    </mt-popup>

                    <mt-popup
                        v-model="popupVisible5"
                        class="popup"
                       >
                       <html style="z-index:1;width:100%;">
                        <div style="padding:2rem">
                           

                                <div    class="poopdiv date">
                                    <div class="title"><span>预计上门时间</span></div>
                                    <div class="mint-cell-value">
                                        <input
                                          placeholder="日期"
                                          @click="ShowStartDatePicker"
                                          v-model="callRequest.CurrentEstimateOnSiteDate"
                                          type="text"
                                          readonly
                                          class="mint-field-core"
                                        />
                                    </div>
                                    <div class="mint-cell-value">
                                      <mt-radio v-if="callRequest.CurrentEstimateOnSiteDate!=''" class="callradio"
                                          v-model="callRequest.CurrentEstimateOnSiteTime"
                                          :options="['上午', '下午']">
                                      </mt-radio>
                                    </div>
                                    
                                </div>
                                <div style="margin-top:20px;" v-if="callRequest.IsOnSiteServiceStr=='远程服务'"  class="poopdiv">
                                    <div style="font-size:1.2rem;font-weight:bold;">备注</div>
                                    <textarea class="proptextarea" placeholder="请输入备注" v-model="callRequest.Comment"></textarea>
                                </div>
                            </div>
                           
                            <div  style="margin-top:20px;" class="confirmdiv">
                               
                                <div @click="ConfirmOnsiteTime" style="width:100%" class="right">确认</div>
                            </div>
                       </html>
                        </mt-popup>
</div>
</template>
<style>
.mint-cell{
    display: flex;
}
.proptextarea{
    background-color: white;
    border:1px solid black;
    width: 100%;
    border-radius: 2px;
    padding:5px;
}
.mint-cell-wrapper{
    width:100%;
}

</style>
<script>
import { Indicator } from 'mint-ui';
import { Button } from 'mint-ui';
import DataTransfer from "../../common/DataTransfer";
import AttachUpload from "@/components/AttachUpload.vue";
import _ from 'lodash';
import {
   MessageBox ,
    Toast,
    
} from 'mint-ui';
export default {
    data() {
        return {
            attachmentList:[],
            createType: 0,
            isOpen2: false,
            isOpen: false,
            CurrentEstimateOnSiteTime:'',
            slots:[{values:['上午','下午']}],
   
            startDatePicker: new Date(),
           
            request:{
                callRquestOrderNo:''
            },
            loading: false,    
             callRequest:{
                callRquestOrderNo:'',
                IsOnSiteServiceStr:"现场服务",
                CurrentEstimateOnSiteDate:'',
                CurrentEstimateOnSiteTime:'',
                Comment:'',
                InWarrantyTimeStr:'质保期内',
                IsRepairStr:'更换',
                IsFreeStr:'免费',
                Result:'',
                attachmentList:[],
                partattachmentList:[],
            },
            popupVisible:false,
            popupVisible2:false,
            popupVisible3:false,
            popupVisible4:false,
            popupVisible5:false,

        };
    },
        components: {
    
        "attach-upload": AttachUpload,
   
        },
        watch:{
          
        },
    methods: {
         ConfirmOnsiteTime(){
             var that=this;
            if(that.callRequest.CurrentEstimateOnSiteDate==''){
                    Toast('请选择日期');
                    return false;
                }
                if(that.callRequest.CurrentEstimateOnSiteTime==''){
                    Toast('请选择上午/下午');
                    return false;
                }
                 that.ConfirmOnsiteTimeSubmit();
        },
        ConfirmOnsiteTimeSubmit(){
            var that=this;
           
           Indicator.open();
            if (that.loading) {
                return;
            }
            that.loading = true;
            
            that.callRequest.callRquestOrderNo=that.$route.query.callRquestOrderNo
            Indicator.open();
            that.$axios
                .post("/api/ServiceCallRequest/ConfirmOnsiteTimeSubmit", that.callRequest)
                .then((res) => {
                    Indicator.close();
                    Toast("提交成功");
                    that.popupVisible3=false;
                    that.loading = false;
                    Indicator.close();
                    if (res.data != null && res.data.isSuccess) {
                       that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        },
        NowSetOnsiteTime(){
            var that=this;
            that.popupVisible5=true;
            
        },
        validation(){
            var that=this;
            
            if(that.callRequest.attachmentList.length==0&&that.callRequest.partattachmentList.length==0){
                Toast("请上传维修凭证");
                return false;
            }
            else if(that.callRequest.Result==''||that.callRequest.Result==null||that.callRequest.Result==undefined){
                Toast("请填写详情内容");
                return false;
            }else{
                return true;
            }
        },
        DateTimeToDate(date){
          date=new Date(date);
          var y = date.getFullYear();  
          var m = date.getMonth() + 1;  
          m = m < 10 ? '0' + m : m;  
          var d = date.getDate();  
          d = d < 10 ? ('0' + d) : d;  
          return y + '-' + m + '-' + d;  
        },
        PartiallyCompleteCallServiceWithNoTime(){
             var that=this;
            if(!that.validation()){
                return false;
            }
            
            Indicator.open();
            that.callRequest.callRquestOrderNo=that.$route.query.callRquestOrderNo;
            that.callRequest.attachmentList=that.callRequest.partattachmentList;
            that.loading = true;
            that.$axios
                .post("/api/ServiceCallRequest/PartiallyCompleteCallServiceWithNoTime", that.callRequest)
                .then((res) => {
                    Toast("部分完修成功");
                   that.popupVisible=false;
                    that.loading = false;
                    Indicator.close();
                   if (res.data != null && res.data.isSuccess) {
                     that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        },
        PartiallyCompleteCallService(){
            
            //部分已填写上门时间完修确认
            var that=this;
           
            if(!that.validation()){
                return false;
            }
            if(that.callRequest.CurrentEstimateOnSiteDate==''){
                    Toast('请选择日期');
                    return false;
                }
            if(that.callRequest.CurrentEstimateOnSiteTime==''){
                    Toast('请选择上午/下午');
                    return false;
            }
            Indicator.open();
            that.callRequest.callRquestOrderNo=that.$route.query.callRquestOrderNo;
            that.callRequest.attachmentList=that.callRequest.partattachmentList;
            that.loading = true;
            that.$axios
                .post("/api/ServiceCallRequest/PartiallyCompleteCallService", that.callRequest)
                .then((res) => {
                    Toast("部分完修成功");
                   that.popupVisible=false;
                    that.loading = false;
                    Indicator.close();
                   if (res.data != null && res.data.isSuccess) {
                     that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        },
        //完修提交处理结果
        CompleteCallService(){
           var that=this;
           if(!that.validation()){
                return false;
            }
           that.callRequest.callRquestOrderNo=that.$route.query.callRquestOrderNo;
            if (that.loading) {
                return;
            }
            
            that.loading = true;
            Indicator.open();
            that.$axios
                .post("/api/ServiceCallRequest/CompleteCallService", that.callRequest)
                .then((res) => {
                    Toast("完修成功");
                   that.popupVisible=false;
                    that.loading = false;
                    Indicator.close();
                   if (res.data != null && res.data.isSuccess) {
                     that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        },
        cancelSubmit(){
            var that=this;
            window.location.reload();
            // that.popupVisible3=false;
            // that.popupVisible4=false;
            // that.callRequest.attachmentList=[];
            // that.callRequest.Result='';
            // that.callRequest.partattachmentList=[];
            console.log(that.callRequest.partattachmentList);
        },
        PartiallyCpmplete(){
            var that=this;
             that.popupVisible4=true;
        },
        CompleteService(){
            var that=this;
            that.popupVisible3=true;
        },
        ArrivePlace(callRquestOrderNo){
            var that=this;
         MessageBox({
        title: '提示',
        message: '确认到达现场?',
        showCancelButton: true
      }).then((res) => {
        if (res === 'confirm') {
             if (that.loading) {
                return;
            }
            Indicator.open();
            that.loading = true;
            that.$axios
                .get("/api/ServiceCallRequest/ArrivePlace?CallRequestNo="+callRquestOrderNo)
                .then((res) => {
                    Toast("修改成功");
                  Indicator.close();
                    that.loading = false;
                 
                    if (res.data.data != null && res.data.isSuccess) {
                       
                     that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        } 
      })
            
        },
        TakeCallReuqestOrder(){
            var that=this;
           
           
            if (that.loading) {
                return;
            }
            that.loading = true;
            Indicator.open();
            that.$axios
                .post("/api/ServiceCallRequest/TakeCallReuqestOrder", that.callRequest)
                .then((res) => {
                    Toast("接单成功");
                   that.popupVisible=false;
                    that.loading = false;
                    Indicator.close();
                   if (res.data != null && res.data.isSuccess) {
                     that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        },
         onValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.CurrentEstimateOnSiteTime = values[0];
            }
        },
        HandleStartDateConfirm(data) {
           var that = this;
           var date=data;
           var yes=new Date().setTime(new Date().getTime()-24*60*60*1000);
           
            if(date<yes){
              Toast('预计上门时间不能小于当前日期');
                
                return false;
            }
            that.callRequest.CurrentEstimateOnSiteDate = DataTransfer.dateToString(data);
           
          
        },
        ConfirmTakeOrder(){
            var that=this;
            //that.popupVisible=false;
            if(that.callRequest.IsOnSiteServiceStr=='现场服务'){
                if(that.callRequest.CurrentEstimateOnSiteDate==''){
                    Toast('请选择日期');
                    return false;
                }
                if(that.callRequest.CurrentEstimateOnSiteTime==''){
                    Toast('请选择上午/下午');
                    return false;
                }
            }
            that.TakeCallReuqestOrder();
            
        },
        WaitTimeConfirmTakeOrder(){
           var that=this;
           
           
            if (that.loading) {
                return;
            }
            that.loading = true;
            Indicator.open();
            that.$axios
                .post("/api/ServiceCallRequest/WaitTimeConfirmTakeOrder", that.callRequest)
                .then((res) => {
                    Toast("接单成功");
                    that.popupVisible=false;
                    that.loading = false;
                  Indicator.close();
                    if (res.data != null && res.data.isSuccess) {
                     that.GetCallRequestByNo();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
             
        },
         confirmSelect(){
          var that = this;
          that.popupVisible2 = false;
          that.callRequest.CurrentEstimateOnSiteTime=that.CurrentEstimateOnSiteTime;
            
       },
        ShowStartDatePicker() {
            var that = this;
           
            that.$refs.startDatePicker.open();
        },
        ShowMorningPicker() {
            var that = this;
            that.popupVisible2=true;
        },
        GetOrder(callRquestOrderNo){
            var that=this;
            that.popupVisible=true;
            that.callRequest.callRquestOrderNo=callRquestOrderNo;
            console.log(that.callRequest);
        },
        CallCustomer(mobile){
            var that=this;
            window.location.href = 'tel://' + mobile
           
        },
      WrongMobile(){
        var that=this;
         MessageBox({
        title: '提示',
        message: '确认顾客的联系电话有误，无法拨打成功，本单将自动关闭并提醒顾客修改联系信息后重新叫修！',
        showCancelButton: true
      }).then((res) => {
        if (res === 'confirm') {
             if (that.loading) {
                return;
            }
            Indicator.open();
            that.loading = true;
            that.$axios
                .get("/api/ServiceCallRequest/ShutdownOrderWithWrongMobile?CallRequestNo="+that.request.callRquestOrderNo)
                .then((res) => {
                    Toast("修改成功");
                  
                    that.loading = false;
                    Indicator.close();
                    if (res.data != null && res.data.isSuccess) {
                     that.Cancel();
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch((err) => {
                    
                   that.loading = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        } 
      })

      },
        Cancel(){
            var that=this;
            var status=localStorage.getItem('ListStatus');
            that.$router.push({
                path: `/CallRequest/list?status=`+status
            });
        },
        GetCallRequestByNo() {
            var that = this;
          
            //这是判断是否已经加载到数据结束参数
           
            if (that.loading) {
                return;
            }
            that.loading = true;
            
           Indicator.open();
            that.$axios
                .get("/api/ServiceCallRequest/GetCallRequestByNo?CallRequestNo="+that.request.callRquestOrderNo)
                .then((res) => {
                    
                   that.loading = false;
                    Indicator.close();
                    
                    var result = res.data;
                   
                   
                    if (result != null && result.isSuccess) {
                        that.request=result.data                      
                        if(that.request.customerTel==null){
                            that.request.customerTel='暂无';
                        }
                        if(that.request.currentInWarrantyTime!=null){
                            if(that.request.currentInWarrantyTime==1){
                                that.callRequest.InWarrantyTimeStr="质保期内";
                            }else{
                                that.callRequest.InWarrantyTimeStr="质保期外";
                            }
                        }
                        if(that.request.currentIsRepair!=null){
                            if(that.request.currentIsRepair==1){
                                that.callRequest.IsRepairStr="更换";
                            }else{
                                that.callRequest.IsRepairStr="维修";
                            }
                        }

                        if(that.request.currentIsFree!=null){
                            if(that.request.currentIsFree==1){
                                that.callRequest.IsFreeStr="免费";
                            }else{
                                that.callRequest.IsFreeStr="有费";
                            }
                        }
                        if(that.request.currentResult!=null){
                            that.callRequest.ShowResult=that.request.currentResult;
                        }else{
                            that.callRequest.ShowResult="请填写本次维修的详情内容"
                        }
                        
                        
                         console.log(that.request);
                    } else {
                        console.log(result.message);
                        that.canLoading = false;
                    }
                })
                .catch((err) => {
                    that.loading = false;
                    that.canLoading = false;
                    Toast("数据加载失败，请稍后再试");
                    console.log(err);
                });
                
        }
    },
    mounted() {
        var that = this;
        
    },
    created() {
       
        var that = this;
        that.request.callRquestOrderNo=that.$route.query.callRquestOrderNo;
        
        that.GetCallRequestByNo();
        

        
        
    },
};
</script>
